export const ADD_PLUGIN_MENU_HORIZONTAL = 'add-plugin-menu-horizontal';
export const ADD_PLUGIN_MENU = 'add-plugin-menu';
export const ADD_PLUGIN_FLOATING_TOOLBAR = 'add-plugin-floating-toolbar';
